import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import { Alert } from 'antd';
import { DiffChecker_URL } from '../../Components/Constant';


let hasExecuted = false;

const UpdateTokenComponent=() =>{
  const [responseStatus, setResponseStatus] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const userId=Cookies.get('userId');
  const token =Cookies.get('tokenRes');



  useEffect(() => {
    if (hasExecuted) {
      return;
    }
    hasExecuted = true;

    const searchParams = new URLSearchParams(window.location.search);
    console.log('search params',searchParams);
    const code = searchParams.get('code');
    const state = searchParams.get('state');


    // Function to update the token
    async function updateToken(state,code) {
      try {
        const response = await axios({
          method: 'put',
          url: `${DiffChecker_URL}/authorize/updateToken`,
          headers: {
            'Content-Type': 'application/json',
          },
          data: {
            UserId: state,
            Token: code,
            JWTToken: token
          },
        });

       
        // Assuming the API sends back a specific status code or message on success
        if (response.status === 200) {
          setResponseStatus('success');
          setTimeout(() => {
            window.location = '/SalesforceTools/Connections';
          }, 
          2000);
        } else {
          // Handle other status codes or conditions as needed
          setResponseStatus('error');
          setErrorMessage('An unexpected status code was received.');
        }
      } catch (error) {
        setResponseStatus('error');
        // Error message handling
        setErrorMessage(
          error.response ? error.response.data : 'An error occurred while updating the token.'
        );
      }
    }

    if (code && state) {
      updateToken(state,code);
    } else {
      setResponseStatus('error');
      setErrorMessage('Code or state not found in URL.');
    }
  }, []);

  return (
    <div>
      {responseStatus === 'success' && (
        <Alert
          message="Success"
          description="The token has been successfully updated. Redirecting..."
          type="success"
          showIcon
        />
      )}
      {responseStatus === 'error' && (
        <Alert
          message="Error"
          description={errorMessage}
          type="error"
          showIcon
        />
      )}
    </div>
  );
}

export default UpdateTokenComponent;